/* eslint-disable */
import * as util from "@/api/autoFollowUp";

const state = {};
const mutations = {};

const actions = {
  listAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.listAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  statsAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.statsAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  storedAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.storedAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  detailAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.detailAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  detailAutoFollowUpSilent({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.detailAutoFollowUpSilent(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  recipientListAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.recipientListAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  stopRecipientAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.stopRecipientAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  eventsAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.eventsAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  activateAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.activateAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  pauseAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.pauseAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  resumeAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.resumeAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  cancelAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.cancelAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  retrySchedulingAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.retrySchedulingAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  licenseQuotaAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.licenseQuotaAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  reconcileLicenseQuotaAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.reconcileLicenseQuotaAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  resetLicenseQuotaAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.resetLicenseQuotaAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  deleteAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.deleteAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  templateStoredAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.templateStoredAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  templateListAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.templateListAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  templateDetailAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.templateDetailAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  templateDeleteAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.templateDeleteAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  templateUseAutoFollowUp({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.templateUseAutoFollowUp(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/autoFollowUp.js